import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  CssBaseline,
  Container,
  Box, // Add Box component from MUI
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { addLegalNotice, removeLegalNoticeItem } from '../../redux/reducers/LegalInformationsReducer';

function LegalNoticeTab() {
  const legalNoticeData = useSelector((state) => state.legalInformations.legalNoticeData);
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [newItem, setNewItem] = useState({ title: '', description: '' });

  const handleDelete = (uid) => {
    dispatch(removeLegalNoticeItem(uid));
  };

  const handleAdd = () => {
    dispatch(addLegalNotice(newItem));
    setNewItem({ title: '', description: '' });
    setOpenDialog(false);
  };

  return (
    <Container component="main" maxWidth="lg">
      <CssBaseline />
      <Box display="flex" justifyContent="center" mt={2}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenDialog(true)}
          style={{ backgroundColor: '#FC6258', color: 'white', textTransform: 'none' }}
        >
          Ajouter
        </Button>
      </Box>
      <div>
        <Typography variant="h4" gutterBottom>
          Mentions légales
        </Typography>
        <List>
          {legalNoticeData.map((item, index) => (
            <ListItem key={index} style={{ borderBottom: '1px solid #ccc' }}>
              <ListItemText primary={item.title} secondary={item.description} />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(item.uid)}>
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </div>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Ajouter de nouvelles mentions légales</DialogTitle>
        <DialogContent>
          <TextField
            label="Titre"
            fullWidth
            value={newItem.title}
            onChange={(e) => setNewItem({ ...newItem, title: e.target.value })}
            margin="normal"
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={4}
            value={newItem.description}
            onChange={(e) => setNewItem({ ...newItem, description: e.target.value })}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
        <Button onClick={() => setOpenDialog(false)} style={{ color: '#FC6258' }}>
  Annuler
</Button>
<Button onClick={handleAdd} variant="contained" style={{ backgroundColor: '#FC6258', color: 'white' }}>
  Ajouter
</Button>

        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default LegalNoticeTab;
